export default __webpack_public_path__ + "static/teamPhoto6-4a00d81860f75648c053e20df6d68d1e.png";